/**
 * Andarta — Gift Line Item Decorator
 * ====================================
 * Détecte les line items cart avec property `_gift: 'true'` et :
 * - Ajoute un badge "🎁 Cadeau offert" gold
 * - Désactive l'input quantité (fixe à 1)
 * - Cache le bouton remove (le gift part avec le seuil)
 * - Affiche le prix barré + "Gratuit"
 *
 * Compatible Dawn natif (main-cart-items) ET Andarta Cinema (cart-items-cinema).
 * Réactif aux mutations DOM (re-applique après cart refresh).
 */

(function () {
  if (window.__andartaGiftLineItemBooted) return;
  window.__andartaGiftLineItemBooted = true;

  const SELECTORS = [
    'cart-items .cart-item',
    '.cart-items__item',
    '.acic__row',
    '[data-line-item]',
  ];

  function findCartItems(root) {
    const set = new Set();
    SELECTORS.forEach((sel) => {
      root.querySelectorAll(sel).forEach((el) => set.add(el));
    });
    return [...set];
  }

  async function getCart() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!res.ok) return null;
      return await res.json();
    } catch { return null; }
  }

  function isGiftItem(item) {
    return item && item.properties && (item.properties._gift === 'true' || item.properties._gift === true);
  }

  function decorateRow(rowEl, lineItem) {
    if (!rowEl || rowEl.dataset.giftDecorated === 'true') return;
    rowEl.dataset.giftDecorated = 'true';
    rowEl.classList.add('andarta-gift-row');

    const nameCell = rowEl.querySelector('.cart-item__name, .cart-item__details, .acic__details, [data-line-item-name]') || rowEl;
    if (nameCell && !nameCell.querySelector('.andarta-gift-badge')) {
      const badge = document.createElement('span');
      badge.className = 'andarta-gift-badge';
      badge.textContent = '🎁 Cadeau offert';
      nameCell.prepend(badge);
    }

    rowEl.querySelectorAll('quantity-input, .quantity, [data-quantity-wrapper]').forEach((q) => q.classList.add('andarta-gift-qty'));
    rowEl.querySelectorAll('input[name="updates[]"], .quantity__input').forEach((input) => {
      input.setAttribute('readonly', 'readonly');
      input.setAttribute('aria-readonly', 'true');
      input.value = '1';
    });
    rowEl.querySelectorAll('.quantity__button, [data-quantity-decrease], [data-quantity-increase]').forEach((btn) => {
      btn.setAttribute('disabled', 'disabled');
      btn.setAttribute('tabindex', '-1');
    });
    rowEl.querySelectorAll('cart-remove-button, a[href*="quantity=0"], .button--small.cart-remove-button, [data-line-item-remove]').forEach((btn) => {
      btn.style.display = 'none';
    });

    const priceCell = rowEl.querySelector('.cart-item__price, .acic__price, [data-line-item-price]');
    if (priceCell && !priceCell.querySelector('.andarta-gift-price-free')) {
      priceCell.classList.add('andarta-gift-price-cell');
    }
  }

  function findRowForLineItem(items, lineItem, index) {
    for (const row of items) {
      const variantInRow = row.dataset.variantId || row.getAttribute('data-variant-id') || row.querySelector('[data-variant-id]')?.dataset.variantId;
      if (variantInRow && parseInt(variantInRow, 10) === lineItem.variant_id) return row;
    }
    return items[index] || null;
  }

  async function refresh() {
    const cart = await getCart();
    if (!cart || !cart.items) return;
    const giftIndices = [];
    cart.items.forEach((it, idx) => { if (isGiftItem(it)) giftIndices.push({ idx, item: it }); });
    if (giftIndices.length === 0) return;

    const cartRoot = document.querySelector('cart-items, cart-drawer-items, .cart, [data-cart-root]') || document.body;
    const rows = findCartItems(cartRoot);
    giftIndices.forEach(({ idx, item }) => {
      const row = findRowForLineItem(rows, item, idx);
      if (row) decorateRow(row, item);
    });
  }

  // Observer sur DOM (cart refresh = sections re-render)
  let observerScheduled = false;
  function scheduleRefresh() {
    if (observerScheduled) return;
    observerScheduled = true;
    setTimeout(() => { observerScheduled = false; refresh(); }, 80);
  }

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType === 1 && (
          node.matches?.('cart-items, cart-drawer-items, .cart-item, [data-line-item]') ||
          node.querySelector?.('cart-items, cart-drawer-items, .cart-item, [data-line-item]')
        )) {
          scheduleRefresh();
          return;
        }
      }
    }
  });

  function init() {
    refresh();
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('cart:updated', () => scheduleRefresh());
    document.addEventListener('cart:refresh', () => scheduleRefresh());
    // Bridge Dawn PubSub natif (cart.js, product-form.js, etc.)
    if (typeof window.subscribe === 'function' && typeof window.PUB_SUB_EVENTS !== 'undefined') {
      try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => scheduleRefresh()); } catch {}
    } else if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try { subscribe(PUB_SUB_EVENTS.cartUpdate, () => scheduleRefresh()); } catch {}
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
